import classNames from 'classnames';

export const CardSection = ({
  children,
  className,
  withBorder = false,
  withMargin = true,
}: {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  withBorder?: boolean;
  withMargin?: boolean;
}) => (
  <div
    className={classNames(className, {
      'mb-4 lg:mb-6': withMargin,
      'border-gray-2 border-b': withBorder,
    })}
  >
    {children}
  </div>
);
